import { Col } from "react-bootstrap";
import { checkValidData } from "components/Formatter";
import ImageElement from "../../ImageElement";

function CapturedCard({ openImageModal1, item }) {
  return <>
    <Col lg={4} sm={6}>
      <div
        className="capturedSec_card"
        onClick={() => {
          openImageModal1(item?.id);
        }}
      >
        <ImageElement
          previewSource={item?.memorialAlbumImageUrl}
          className="img-fluid"
          alt="navigating"
        />
        <div className="capturedSec_card_cnt d-flex align-items-center justify-content-between w-100">
          <h3>
            {checkValidData(item?.name)}
          </h3>
          <em className="icon-album" />
        </div>
      </div>
    </Col>
  </>
}

export default CapturedCard;
